module.exports = __webpack_public_path__ + "img/ics_f_announce_sdn.3ae9b7d4.svg";